const lightColors = {
  colorNeutral: 'hsl(216, 13%, 53%)',
  colorPrimary: 'hsl(205, 97%, 35%)',
  colorSecondary: 'hsl(329, 75%, 30%)',
  colorAlert: 'hsl(360, 100%, 42%)',
  colorWarning: 'hsl(40, 100%, 28%)',
  colorSuccess: 'hsl(124, 85%, 26%)',
  colorInfo: 'hsl(205, 99%, 37%)',
  colorStatusNeutral: 'hsl(216, 13%, 45%)',
  colorUiLight: 'hsl(0, 100%, 100%)',
  colorUiMedium: 'hsl(210, 17%, 98%)',
  colorUiDark: 'hsl(220, 13%, 95%)',
  colorUiBorder: 'hsl(218, 12%, 83%)',
  colorUiPop: 'hsl(205, 97%, 41%)',
  colorTextDefault: 'hsl(0, 0%, 0%)',
  colorTextLabel: 'hsl(218, 13%, 46%)',
  colorTextInverse: 'hsl(0, 100%, 100%)',
  colorTextPrimary: 'hsl(205, 97%, 35%)',
  colorTextSecondary: 'hsl(329, 75%, 30%)',
  colorTextPop: 'hsl(0, 0%, 100%)',
  colorGraph1: '#33a3ff',
  colorGraph2: '#ffcc32',
  colorGraph3: '#9471ff',
  colorGraph4: '#ff8224',
  colorGraph5: '#2ad1d1',
  colorGraph6: '#dd5757',
  colorGraph7: '#15b57b',
  colorGraph8: '#ff6fbd',
  colorKPI1: '#dd5757',
  colorKPI3: '#ffcc32',
  colorKPI5: '#15b57b'
};
const darkColors = {
  colorNeutral: 'hsl(205, 25%, 70%)',
  colorPrimary: 'hsl(205, 97%, 63%)',
  colorSecondary: 'hsl(329, 75%, 43%)',
  colorAlert: 'hsl(360, 100%, 65%)',
  colorWarning: 'hsl(40, 100%, 58%)',
  colorSuccess: 'hsl(124, 85%, 36%)',
  colorInfo: 'hsl(205, 99%, 59%)',
  colorStatusNeutral: 'hsl(205, 25%, 70%)',
  colorUiLight: 'hsl(205, 90%, 8%)',
  colorUiMedium: 'hsl(205, 90%, 15%)',
  colorUiDark: 'hsl(205, 90%, 12%)',
  colorUiBorder: 'hsl(205, 22%, 26%)',
  colorUiPop: 'hsl(205, 90%, 15%)',
  colorTextDefault: 'hsl(0, 100%, 100%)',
  colorTextLabel: 'hsl(223, 10%, 64%)',
  colorTextInverse: 'hsl(205, 90%, 8%)',
  colorTextPrimary: 'hsl(205, 97%, 63%)',
  colorTextSecondary: 'hsl(329, 75%, 43%)',
  colorTextPop: 'hsl(0, 0%, 100%)',
  colorGraph1: '#2470ad',
  colorGraph2: '#98863c',
  colorGraph3: '#5954ad',
  colorGraph4: '#985b30',
  colorGraph5: '#238a92',
  colorGraph6: '#84414b',
  colorGraph7: '#17785f',
  colorGraph8: '#985186',
  colorKPI1: '#84414b',
  colorKPI3: '#98863c',
  colorKPI5: '#17785f'
};
const highContrastColors = {
  colorNeutral: 'hsl(205, 30%, 90%)',
  colorPrimary: 'hsl(205, 97%, 76%)',
  colorSecondary: 'hsl(329, 75%, 90%)',
  colorAlert: 'hsl(360, 80%, 80%)',
  colorWarning: 'hsl(40, 80%, 75%)',
  colorSuccess: 'hsl(124, 60%, 75%)',
  colorInfo: 'hsl(205, 80%, 75%)',
  colorStatusNeutral: 'hsl(205, 30%, 90%)',
  colorUiLight: 'hsl(0, 0%, 0%)',
  colorUiMedium: 'hsl(212, 10%, 17%)',
  colorUiDark: 'hsl(0, 0%, 0%)',
  colorUiBorder: 'hsl(218, 12%, 83%)',
  colorUiPop: 'hsl(212, 10%, 12%)',
  colorTextDefault: 'hsl(0, 0%, 100%)',
  colorTextLabel: 'hsl(0, 0%, 100%)',
  colorTextInverse: 'hsl(0, 0%, 0%)',
  colorTextPrimary: 'hsl(205, 97%, 76%)',
  colorTextSecondary: 'hsl(329, 75%, 90%)',
  colorTextPop: 'hsl(0, 0%, 100%)',
  colorGraph1: '#4aacff',
  colorGraph2: '#f1d700',
  colorGraph3: '#c68aff',
  colorGraph4: '#f98e39',
  colorGraph5: '#00d692',
  colorGraph6: '#ff817a',
  colorGraph7: '#7cbf00',
  colorGraph8: '#ff6fbd',
  colorKPI1: '#ff5e4d',
  colorKPI3: '#f2d94b',
  colorKPI5: '#7bb04a'
};
const colors = {
  neutral: '#768396',
  primary: '#0378cd',
  secondary: '#86134f',
  alert: '#d80000',
  warning: '#916000',
  success: '#0a7c12',
  information: '#016DBA'
};
export const LightThemeParameters = {
  baseThemeName: 'light',
  colors: {
    ...colors,
    ...lightColors
  },
  enableNovaTokens: false
};
export const DarkThemeParameters = {
  ...LightThemeParameters,
  colors: {
    ...LightThemeParameters.colors,
    ...darkColors
  },
  baseThemeName: 'dark'
};
export const HighContrastThemeParameters = {
  ...LightThemeParameters,
  baseThemeName: 'high-contrast',
  colors: {
    ...LightThemeParameters.colors,
    secondary: '#EA6CAD',
    alert: '#ff6347',
    warning: '#daa520',
    success: '#32cd32',
    information: '#22a7f0',
    ...highContrastColors
  }
};
export const defaultThemes = {
  light: LightThemeParameters,
  dark: DarkThemeParameters,
  'high-contrast': HighContrastThemeParameters
};

/**
 * SAS system application theme's theme parameters.
 */
export const ApplicationThemeParametersMap = {
  sas_corporate: {
    baseThemeName: 'light',
    colors: {
      ...colors,
      ...lightColors
    }
  },
  sas_ignite: {
    baseThemeName: 'dark',
    colors: {
      ...colors,
      ...darkColors
    }
  },
  sas_hcb: {
    baseThemeName: 'high-contrast',
    colors: {
      ...colors,
      secondary: '#EA6CAD',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0',
      ...highContrastColors
    }
  }
};

/**
 * SAS system report theme's theme parameters.
 */
export const ReportThemeParametersMap = {
  marine: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  midnight: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#fff',
      primary: '#0378cd',
      secondary: '#0378cd',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  midnight2020: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#fff',
      primary: '#0378cd',
      secondary: '#0378cd',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  opal: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#3c444f',
      secondary: '#3c444f',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  // NOTE: Aqua and sail are the same theme
  // https://rndconfluence.sas.com/confluence/pages/viewpage.action?pageId=92737303#OpenUIReport&GraphWorkflowDocumentation-ReportThemes
  sail: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#0072b2'
    }
  },
  aqua: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#0072b2'
    }
  },
  umstead: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  highcontrast2020: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#fff',
      primary: '#0378cd',
      secondary: '#86134f',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  // highcontrast2018 and highcontrast2017 should receive the same treatment
  highcontrast2018: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#fff',
      primary: '#44affc',
      secondary: '#ea6cad',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0'
    }
  },
  highcontrast2017: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#fff',
      primary: '#98fb98',
      secondary: '#0ff',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0'
    }
  },
  // Legacy
  light: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  dark: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  snow: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  highcontrast: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#ffffff',
      primary: '#00fffc',
      secondary: '#00fffc',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  light2025: {
    baseThemeName: 'light',
    colors: {
      neutral: '#788497',
      primary: '#0368b0',
      secondary: '#86134e',
      alert: '#d60000',
      warning: '#8f5f00',
      success: '#0a7b11',
      information: '#016ebc'
    }
  },
  dark2025: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#fff',
      primary: '#45b0fc',
      secondary: '#c01b70',
      alert: '#ff4d4d',
      warning: '#ffb829',
      success: '#0eaa18',
      information: '#2fa8fe'
    }
  },
  highcontrast2025: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#dee7ed',
      primary: '#86ccfd',
      secondary: '#f9d2e6',
      alert: '#f5a3a3',
      warning: '#f2d08c',
      success: '#99e69e',
      information: '#8cc8f2'
    }
  }
};

/**
 * SAS system theme's (application and report themes) theme parameters.
 */
export const ThemeIdMap = {
  ...ReportThemeParametersMap,
  ...ApplicationThemeParametersMap
};
//# sourceMappingURL=themeParameters.js.map